<button
  class="AmButtonCalendar"
  (click)="handleCalendar()"
  [ngClass]="{ 'AmButtonCalendar--fullSize': fullSize }"
>
  <span class="fs-24px lh-32px fw-medium-x text-am-blue">{{ dateSelected | localizedDate: "dd MMM." | lowercase }}</span>
  <img alt="" src="../../../../assets/images/calendar.svg" />
</button>